export default __webpack_public_path__ + "static/media/union_design_3.cf3ff450.png";